import React from 'react';
import './Tag.css';

/**
 * 标签组件 - 用于显示参数、状态等信息
 * Tag Component - For displaying parameters, status, etc.
 * 
 * @param {Object} props
 * @param {'primary'|'secondary'|'success'|'warning'|'danger'|'info'|'time'|'result'|'note'} props.variant - 标签变体
 * @param {'sm'|'md'|'lg'} props.size - 标签尺寸
 * @param {React.ReactNode} props.children - 标签内容
 * @param {React.ReactNode} props.icon - 图标
 * @param {boolean} props.closable - 是否可关闭
 * @param {Function} props.onClose - 关闭回调
 * @param {string} props.className - 额外的CSS类名
 */
const Tag = ({
  variant = 'secondary',
  size = 'md',
  children,
  icon,
  closable = false,
  onClose,
  className = '',
  ...props
}) => {
  const baseClass = 'tag';
  const variantClass = `tag--${variant}`;
  const sizeClass = `tag--${size}`;
  const closableClass = closable ? 'tag--closable' : '';
  
  const tagClass = [
    baseClass,
    variantClass,
    sizeClass,
    closableClass,
    className
  ].filter(Boolean).join(' ');

  const handleClose = (e) => {
    e.stopPropagation();
    onClose?.(e);
  };

  return (
    <span className={tagClass} {...props}>
      {icon && (
        <span className="tag__icon">
          {icon}
        </span>
      )}
      
      <span className="tag__content">
        {children}
      </span>
      
      {closable && (
        <button
          type="button"
          className="tag__close"
          onClick={handleClose}
          aria-label="关闭标签"
        >
          <svg
            className="tag__close-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      )}
    </span>
  );
};

export default Tag;
